import axios from "axios";

import Echo from "laravel-echo";
// biome-ignore lint/correctness/noUnusedImports: needed for echo
import Pusher from "pusher-js";

import { toast } from "react-toastify";

window.toastr = toast;
window.axios = axios;

axios.defaults.withCredentials = true;
axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

export async function getCsrfToken() {
	await axios.get("/sanctum/csrf-cookie");
}
const xsrfToken = document.cookie
	.split("; ")
	.find((row) => row.startsWith("XSRF-TOKEN="))
	?.split("=")[1];

const echo = new Echo({
	broadcaster: "pusher",
	key: import.meta.env.VITE_PUSHER_APP_KEY,
	cluster: import.meta.env.VITE_PUSHER_APP_CLUSTER,
	forceTLS: true,
	auth: {
		headers: {
			"X-XSRF-TOKEN": decodeURIComponent(xsrfToken),
		},
	},
});

window.Echo = echo;
export default echo;
